import {useEffect, useState} from 'react'
import {Form} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import Select from 'react-select'
import {processGet} from '../../../services/api'

export const EventCategoryFilter = (props: any) => {
  let eventCategory = props.eventCategory ?? 0
  const intl = useIntl()
  const [categories, setCategories] = useState([])
  const [alleventcat, sertAllEventcat] = useState('1')
  const [category_selected, setCategorySelected] = useState<any>(null)

  useEffect(() => {
    const fetchCategories = async () => {
      let cats: any = await processGet('operation-ranking/event-categories/' + eventCategory)
      setCategories(cats.data)
    }
    fetchCategories()
  }, [eventCategory])

  useEffect(() => {
    props.onChangedEventCategory?.(alleventcat)
  }, [props, alleventcat])

  useEffect(() => {
    props.onChangedCategorySelected?.(category_selected)
  }, [props, category_selected])

  return (
    <>
      <div className='row mb-3'>
        <div className='col-12'>
          <label htmlFor='date_range' className='fw-bold fs-6'>
            {intl.formatMessage({
              id: 'GENERIC.EVENT_CATEGORY_OF_INTEREST',
            })}
          </label>
          <Form.Check
            type='radio'
            id='all_category'
            value='1'
            label={intl.formatMessage({
              id: 'GENERIC.ALL_CATEGORIES',
            })}
            checked={alleventcat === '1'}
            onChange={(e) => sertAllEventcat(e.target.value)}
            className='mb-2'
          />
          <Form.Check
            type='radio'
            id='more_categories'
            value='0'
            label={intl.formatMessage({
              id: 'GENERIC.ONE_OR_MORE_CATEGORIES',
            })}
            checked={alleventcat === '0'}
            className='mb-2'
            onChange={(e) => sertAllEventcat(e.target.value)}
          />
        </div>
      </div>

      {alleventcat === '0' && (
        <>
          <div className='row mb-3'>
            <div className='col-12'>
              <label htmlFor='grouping_by' className='fw-bold fs-6'>
                {intl.formatMessage({
                  id: 'GENERIC.SELECT_CATEGORIES',
                })}
              </label>
            </div>
            <div className='col-12'>
              <Select
                isMulti={true}
                name='server_group'
                options={categories.map((cat: any) => ({
                  value: cat.event_enumerator_code,
                  label: cat.eventcat_description,
                }))}
                classNamePrefix='select'
                onChange={(selectedOption) => {
                  setCategorySelected(selectedOption)
                }}
                value={category_selected}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}
